import { Pipe, PipeTransform } from '@angular/core';
import { ReferenceArea } from '../../reference-areas/models/reference-area';

@Pipe({
  name: 'filterReference'
})
export class FilterReferencePipe implements PipeTransform {

  transform(referenceAreas: ReferenceArea[],legends: any[], isSingleTrain?: boolean): ReferenceArea[] {
    return legends && !isSingleTrain ? referenceAreas.filter(referenceArea =>!! legends.filter(legend => legend.visible).find(legend => legend.name.toLowerCase() === (referenceArea.type.toLowerCase() + "s"))) : referenceAreas;
  }

}
